import React from 'react';
import { Link } from 'react-router-dom';
import URI from 'urijs';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';

// images
import notfound from '../../partials/agent-card/images/notfound.png';

function DesignationResult({ record }) {
  return (
    <tr>
      <td className={cx(BS.textCenter, BS.dNone, BS.dMdTableCell)}>
        <img
          src={`/images/designations/${record.designationImage}`}
          alt={`${record.title} Logo`}
          onError={e => {
            e.target.src = notfound;
            e.target.className = cx(e.target.className, BS.b1);
          }}
          className={cx({
            [BS.b1]: !record.designationImage
          })}
        />
      </td>
      <td>
        <div className={cx(BS.textCenter, BS.dMdNone)}>
          <h6>{record.title}</h6>
          <img
            className={cx(BS.pb3, BS.pt3, {
              [BS.b1]: !record.designationImage
            })}
            src={`/images/designations/${record.designationImage}`}
            alt={`${record.title} Logo`}
            onError={e => {
              e.target.src = notfound;
              e.target.className = cx(e.target.className, BS.b1);
            }}
          />
        </div>
        <h6 className={cx(BS.dNone, BS.dMdBlock)}>{record.title}</h6>
        <p
          dangerouslySetInnerHTML={{
            __html: record.description
          }}
        />
        {record.numAgents > 0 && (
          <p>
            <Link
              to={URI('/find-naples-agent')
                .search({
                  designation: record.id
                })
                .toString()}
            >
              View {record.numAgents} agents with this designation
            </Link>
          </p>
        )}
      </td>
    </tr>
  );
}

export default DesignationResult;



// WEBPACK FOOTER //
// ./src/containers/DesignationSearch/DesignationResult.js